import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { ApiResponse, User } from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

interface UpdateUserData {
  userId: string;
  userData: Partial<{
    loginId: string;
    password: string;
    passwordConfirm: string;
    name: string;
    email: string;
    fullAddress: string;
    mobilePhone: string;
    phone: string;
    role: string;
    smsReceive: boolean;
    description: string;
    siteIds: string[];
  }>;
}

export const useUpdateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.users.updateUser],
    mutationFn: async ({ userId, userData }: UpdateUserData): Promise<User> => {
      const response = await XHRAuthorizedClient.put<ApiResponse<User>>(
        ENDPOINTS.users.update(userId),
        userData
      );
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('유저 업데이트 오류:', error);
    },
  });
};
